import { Link } from 'gatsby';
import React from 'react';
import * as styles from './Subnav.module.scss';

export default function Subnav({items}) {
  return (
    <section className={styles.subnav}>
      <div className={styles.wrapper}>
        {
          items.map(item => <div key={item.id} className={styles.item}><Link to={item.href} className={styles.text} activeClassName='active'>{item.text}</Link></div>)
        }
      </div>
    </section>
  );
}